import { ICompany, ICompanyPatchData } from "Bands/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IDataKeys, IJSONAPIItem, IAPIError } from "shared/types";

interface IJSONAPIMap {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPICompanyCollection {
  [IDataKeys.company]: IJSONAPIMap;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export interface IJSONAPIInvoiceCollection {
  invoice: IJSONAPIMap;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class CompanyService {
  static createCompany = (data: Omit<ICompany, "id">): Promise<IJSONAPICompanyCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const company = await APIService.post({
          path: API_ENDPOINTS.COMPANIES,
          data,
        });
        resolve(company);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_COMPANY);
        reject(error);
      }
    });

  static editCompany = (
    companyId: string,
    companyData: ICompanyPatchData
  ): Promise<IJSONAPICompanyCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const company = await APIService.patch({
          path: API_ENDPOINTS.COMPANY(companyId),
          data: companyData,
        });
        resolve(company);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_COMPANY);
        reject(error);
      }
    });

  static getCompany = (companyId: string): Promise<IJSONAPICompanyCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const company: unknown = await APIService.get({
          path: API_ENDPOINTS.COMPANY(companyId),
        });

        resolve(company as IJSONAPICompanyCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_COMPANIES);
        reject(error);
      }
    });

  static getCompanies = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] }
  ): Promise<IJSONAPICompanyCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const companyIds = await APIService.get({
          path: API_ENDPOINTS.COMPANIES,
          data: queryParams,
        });
        resolve(companyIds as IJSONAPICompanyCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_COMPANIES);
        reject(error);
      }
    });

  static getInvoices = (queryParams?: { [key: string]: any }): Promise<IJSONAPIInvoiceCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const companyIds = await APIService.get({
          path: API_ENDPOINTS.COMPANY_INVOICES,
          data: queryParams,
        });
        resolve(companyIds as IJSONAPIInvoiceCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_INVOICES);
        reject(error);
      }
    });
}
